import React from "react";
import { Link, useNavigate } from "react-router-dom";
import LanguageLink from "../routing/LanguageLink";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function HeaderComponents() {
  const navigate = useNavigate();
  const { role, logout } = useAuth();
  const { t, i18n } = useTranslation();

  const isLoggedIn = !!localStorage.getItem("auth_token");

  const handleLogout = () => {
    logout();
    navigate(`/${i18n.language}/login`);
  };

  const getProfilePath = () => {
    switch (role) {
      case "office_owner":
        return "/profile/office";
      case "lawyer":
        return "/profile/lawyer";
      case "client":
        return "/profile/client";
      case "paralegal":
        return "/profile/paralegal";
      default:
        return "/profile";
    }
  };

  return (
    <div className="hidden lg:flex items-center space-x-4">
      {isLoggedIn ? (
        <>
          <Link
            to={getProfilePath()}
            className="relative p-2.5 rounded-full bg-gray-100 hover:bg-blue-50 text-gray-700 hover:text-blue-600 transition-all duration-200 group"
            title={t("header.nav.profile")}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-blue-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
          </Link>

          <div className="h-6 w-px bg-gray-300"></div>

          <button
            onClick={handleLogout}
            className="p-2.5 rounded-full bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-700 transition-all duration-200 group"
            title={t("header.nav.logout")}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
          </button>
        </>
      ) : (
        <>
          <LanguageLink
            to="/login"
            className="px-5 py-2.5 text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors duration-200"
          >
            {t("header.nav.login")}
          </LanguageLink>

          <LanguageLink
            to="/register"
            className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-full shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
          >
            {t("header.nav.get_started")}
          </LanguageLink>
        </>
      )}
    </div>
  );
}